import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onAuxclick", "onMouseenter"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "last_viewed_client_img",
  src: "/assets/img/close.svg"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "flex last_viewed_client_hover_contract"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(['last_viewed_client_wrapper', { 'is-dragging': _ctx.isDragging, 'is-scrollable': _ctx.isScrollable }]),
      ref: "wrapperRef",
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onWrapperLeave && _ctx.onWrapperLeave(...args))),
      onWheel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onWheel && _ctx.onWheel(...args))),
      onPointerdown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
      onPointermove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPointerMove && _ctx.onPointerMove(...args))),
      onPointerup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args))),
      onPointercancel: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPointerCancel && _ctx.onPointerCancel(...args)))
    }, [
      _createVNode(_TransitionGroup, {
        tag: "div",
        name: "tab",
        class: "last_viewed_client_inner",
        ref: "innerRef"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastViewedClients, (lastViewedClient, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(lastViewedClient.id == _ctx.currentClientId ? 'last_viewed_client last_viewed_client_active' : 'last_viewed_client'),
              style: _normalizeStyle(_ctx.tabStyle(lastViewedClient, index)),
              key: lastViewedClient.id,
              onAuxclick: ($event: any) => (_ctx.onAuxClick($event, index)),
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["middle","prevent"])),
              onMouseenter: ($event: any) => (_ctx.onTabEnter($event, lastViewedClient, index)),
              onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTabLeave && _ctx.onTabLeave(...args)))
            }, [
              _createElementVNode("p", {
                class: "last_viewed_client_p",
                onClick: ($event: any) => (_ctx.onClick(lastViewedClient.id))
              }, [
                (lastViewedClient.contractStatus != null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass('dot dot_contract_' + _ctx.getContractStatus(lastViewedClient.contractStatus))
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(lastViewedClient.fi), 1)
              ], 8, _hoisted_2),
              _createElementVNode("div", {
                class: "last_viewed_client_img_wrapper",
                onClick: ($event: any) => (_ctx.onDelete(index))
              }, _hoisted_5, 8, _hoisted_3)
            ], 46, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }, 512)
    ], 34), [
      [_vShow, _ctx.lastViewedClients.length > 0]
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.hoveredTab)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['last_viewed_client_hover_floating', { last_viewed_client_hover_end_floating: _ctx.hoveredIsEnd }]),
            style: _normalizeStyle(_ctx.tooltipStyle)
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.hoveredTab.title), 1),
            (_ctx.hoveredTab.contractName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.hoveredTab.contractName), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass('dot dot_contract_' + _ctx.getContractStatus(_ctx.hoveredTab.contractStatus))
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('contract_status.' + _ctx.getContractStatus(_ctx.hoveredTab.contractStatus))), 1)
                ]))
              : _createCommentVNode("", true)
          ], 6))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}